/**-------------------------------------------------------------------------
 * Customer Password Recovery
 */
import i18n from 'i18next';

const { UI } = Mobi2Go;
const { Customer } = Mobi2Go;
const { helpers } = Mobi2Go;

Mobi2Go.UI.View({
    name: 'customer_password_recovery',
    model: 'Customer',
    el: '[data-view="customer-password-recovery"]',
    initialise() {
        const that = this;
        this.modal = new Mobi2Go.UI.Modal(this.$el);
        this.email = '';
        this.$el.localize();

        UI.bind('showCustomerPasswordRecovery', function(email) {
            that.email = email;
            that.open();
        });

        this.$reset_code = this.jQuery('[data-reset-code]');
        this.$new_password = this.jQuery('[data-new-password]');
    },
    open() {
        if (this.modal.is_open) {
            return;
        }

        this.modal.open();
        this.modal.freeze();
        this.resetInputs();
    },
    close() {
        this.modal.unfreeze();
        this.modal.close();
    },
    cancel() {
        const that = this;
        UI.centeredAlert({
            title: i18n.t('customer.password-recovery:cancel_alert_title'),
            body: i18n.t('customer.password-recovery:cancel_alert_body'),
            primary_button: i18n.t(
                'customer.password-recovery:cancel_alert_primary_button'
            ),
            secondary_button: i18n.t(
                'customer.password-recovery:cancel_alert_secondary_button'
            ),
            onPrimaryButtonClick() {
                UI.trigger('customerPasswordRecoveryCancelled');
                that.close();
            },
        });
    },
    DOM_listeners: {
        'click [data-set-password]': 'loginAndSetNewPassword',
        'keyup [data-reset-code]': function(e) {
            if (e.keyCode === 13) {
                this.$new_password.focus();
            }
        },
        'keyup [data-new-password]': function(e) {
            if (e.keyCode === 13) {
                this.loginAndSetNewPassword();
            }
        },
        'click [data-cancel]': 'cancel',
    },
    loginAndSetNewPassword() {
        const that = this;
        const reset_code = this.$reset_code.val().trim();
        const new_password = this.$new_password.val();

        if (reset_code === '') {
            this.emptyResetCodeWarning();
            return;
        }

        if (!helpers.validator.password(reset_code).is_valid) {
            this.invalidResetCodeWarning();
            return;
        }

        if (new_password === '') {
            this.emptyPasswordWarning();
            return;
        }

        if (!helpers.validator.password(new_password).is_valid) {
            this.invalidPasswordWarning();
            return;
        }

        this.startLoading();

        if (Customer.isLoggedIn()) {
            Customer.updatePassword(reset_code, new_password, function(result) {
                that.finishLoading();
                if (result === 'success') {
                    that.resetInputs();
                    that.close();
                } else {
                    that.invalidResetCodeWarning();
                }
            });
        } else {
            Customer.resetPassword(this.email, reset_code, new_password, function(is_successful) {
                if (is_successful) {
                    that.resetInputs();
                    that.close();
                    that.finishLoading();
                } else {
                    that.finishLoading();
                    that.invalidResetCodeWarning();
                }
            });
        }
    },
    emptyResetCodeWarning() {
        UI.centeredAlert({
            title: i18n.t('customer.password-recovery:enter_reset_code_title'),
            body: i18n.t('customer.password-recovery:enter_reset_code_body'),
            temp: true,
            primary_button: false,
        });
    },

    invalidResetCodeWarning() {
        UI.centeredAlert({
            title: i18n.t(
                'customer.password-recovery:invalid_reset_code_title'
            ),
            body: i18n.t('customer.password-recovery:invalid_reset_code_body'),
            // temp: true,
            primary_button: false,
        });
    },

    emptyPasswordWarning() {
        UI.centeredAlert({
            title: i18n.t('customer.password-recovery:enter_password_title'),
            body: i18n.t('customer.password-recovery:enter_password_body'),
            temp: true,
            primary_button: false,
        });
    },

    invalidPasswordWarning() {
        UI.centeredAlert({
            title: i18n.t('customer.password-recovery:invalid_password_title'),
            body: i18n.t('customer.password-recovery:invalid_password_body'),
            temp: true,
            primary_button: false,
        });
    },

    resetInputs() {
        this.$reset_code.val('');
        this.$new_password.val('');
    },

    startLoading() {
        this.jQuery('[data-set-password]').addClass('m2g-hidden');
        this.jQuery('[data-loader]').removeClass('m2g-hidden');
    },
    finishLoading() {
        this.jQuery('[data-set-password]').removeClass('m2g-hidden');
        this.jQuery('[data-loader]').addClass('m2g-hidden');
    },
});
